import * as React from "react";
import { CloseIcon } from "./CloseIcon";
import { Flex, Typography } from "antd";

import styles from "./actionModal.module.css";

interface IHederProps {
  onClose: () => any;
  title?: string;
  centered?: boolean;
}

export const Header = ({ title, onClose, centered = false }: IHederProps) => (
  <Flex vertical className={styles.modalHeader}>
    <Flex align="center" onClick={onClose} className={`cursor-pointer ${styles.close}`}>
      <CloseIcon size="14" hover={true} fill="#0A0606" />
    </Flex>
    {title && (
      <Flex className={styles.titleBlock}>
        <Typography.Text className={`${styles.title} ${centered ? styles.centeredTitle : ""}`}>{title}</Typography.Text>
      </Flex>
    )}
  </Flex>
);
